import React, {Component} from 'react';
import {Route, Switch} from "react-router-dom";

import Create from "./components/create"
import Index from "./components/index"
import Edit from "./components/edit"

class User extends Component {
    render() {

        return (
            <div>
                <Switch>
                    {/*<Route exact path="/user" component={UserList}></Route>*/}
                    <Route exact path={this.props.match.path} component={Index}></Route>

                    {/*<Route path="/user/create" component={UserCreate}></Route>*/}
                    <Route path={`${this.props.match.path}/create`} component={Create}></Route>

                    <Route path={`${this.props.match.path}/edit/:id`} component={Edit}></Route>

                    {/*<Redirect to="/"></Redirect>*/}
                </Switch>
            </div>
        )
    }
}

export default User;